import ArrowLeft from "../../../assets/icons/Arrow/ArrowLeft";
import { CategoryInfo, CategoryType } from "../../../store/slice/productsSlice";
import Tags from "../../Tags/Tags";
import "./MobileMenu.scss";
import { useMemo, useState } from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";

const ListItemProducts = ({
  category,
  categories,
  navigate,
  setActiveCategory,
  setShowMenuMobile,
  setShowList,
}: {
  category?: CategoryType;
  categories?: CategoryInfo[] | CategoryType[];
  navigate: NavigateFunction;
  setActiveCategory: React.Dispatch<React.SetStateAction<string | undefined>>;
  setShowMenuMobile: React.Dispatch<React.SetStateAction<boolean>>;
  setShowList: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const handleClick = (tag: CategoryInfo) => {
    if (category?.code) {
      setShowMenuMobile(false);
      navigate(`/category-product/${category?.code}/${tag.code}`);
    } else {
      setActiveCategory(tag.code);
    }
  };

  return (
    <div>
      <div
        className="header-list"
        onClick={() =>
          category ? setActiveCategory(undefined) : setShowList(false)
        }
      >
        <ArrowLeft />
        <div>{category?.name ?? "PRODUITS"}</div>
      </div>

      <div className="list-item">
        <Tags tags={categories} onClick={handleClick} />
      </div>
    </div>
  );
};

const MobileMenu = ({
  categories,
  setShowMenuMobile,
  headerItems,
}: {
  categories: CategoryType[];
  setShowMenuMobile: React.Dispatch<React.SetStateAction<boolean>>;
  headerItems: { name: string; onClick?: () => void }[];
}) => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState<string | undefined>(
    undefined
  );
  const [showListItem, setShowListItem] = useState(false);

  const currentList = useMemo(
    () => categories.find((cat) => cat.code === activeCategory),
    [categories, activeCategory]
  );

  const handleGoTo = (onClick: () => void) => {
    setShowMenuMobile(false);
    onClick();
  };

  return (
    <div className="mobile-menu">
      {showListItem ? (
        <ListItemProducts
          navigate={navigate}
          category={currentList}
          categories={activeCategory ? currentList?.subcategories : categories}
          setActiveCategory={setActiveCategory}
          setShowMenuMobile={setShowMenuMobile}
          setShowList={setShowListItem}
        />
      ) : (
        <div className="header-items">
          {headerItems.map((item) => (
            <div
              onClick={() =>
                item?.onClick
                  ? handleGoTo(item.onClick)
                  : setShowListItem(!showListItem)
              }
            >
              <p>{item.name}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileMenu;
